import { getVWOUserId } from '@/helpers/vwo/getVWOUserId';
import getVWOClientInstance from '@/helpers/vwo/instance';
import { VWOFlag, VWOGoal } from '@/types/vwo';

export { VWOFlag };

export const trackVWOGoal = async (
  featureKey: VWOFlag,
  goalKey: VWOGoal,
  variableKey = 'variant',
): Promise<boolean> => {
  const vwoClient = await getVWOClientInstance();
  if (!vwoClient) return false;

  const userId = getVWOUserId();
  const featureVariableValue = vwoClient.getFeatureVariableValue(featureKey, variableKey, userId);
  vwoClient.track(featureKey, userId, goalKey, {
    customVariables: {
      variationName: featureVariableValue,
    },
  });
  return true;
};
